/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { bindAll } from "lodash";
import { View } from "backbone.marionette";
import template from "templates/modal/modal_embed.hbs";

export default class ModalEmbed extends View.extend({
  template,
  modalWidth: "90%",
  modalMaxWidth: "1100",

  triggers: {
    'click [data-behavior="dismiss"]': "click:dismiss",
    'click [data-copy]': "click:copy"
  }
}) {
  onKeyUp(e) {
    const code = e.keyCode != null ? e.keyCode : e.which;
    if (code === 27) {
      return this.onClickDismiss();
    }
  }

  onClickDismiss() {
    return Radio.channel("app").trigger("modal:close");
  }

  onClickCopy(event) {
    navigator.clipboard.writeText(this.model.attributes.embed_snippet)
  }

  serializeModel() {
    return this.model.toJSON();
  }

  onDestroy() {
    return $(window).off("keyup", this.onKeyUp);
  }

  initialize(options) {
    bindAll(this, "onKeyUp");
    return $(window).on("keyup", this.onKeyUp);
  }
}
